import { render, staticRenderFns } from "./EOEmpress.vue?vue&type=template&id=061ec592&"
import script from "./EOEmpress.vue?vue&type=script&lang=js&"
export * from "./EOEmpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports